import { render, staticRenderFns } from "./radioStatic.vue?vue&type=template&id=0948f969"
import script from "./radioStatic.vue?vue&type=script&lang=js"
export * from "./radioStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports